import React from 'react'
import ReactDOM from 'react-dom'
import App from 'App'
import AppProviders from 'AppProviders'
import { BrowserRouter as Router } from 'react-router-dom'
import 'analytics/TagManager'
import './index.css'
import 'react-loading-skeleton/dist/skeleton.css'

const AppToRender = () => {
  return (
    <React.StrictMode>
      <Router>
        <AppProviders>
          <App />
        </AppProviders>
      </Router>
    </React.StrictMode>
  )
}

ReactDOM.render(<AppToRender />, document.getElementById('root'))
